export default function parseErrorMessage(errorType: Error) {
    if (errorType instanceof TypeError)
        return 'Vegkart finner ikke vegobjektene. Vennligst kontakt support om du mener de skal eksistere.';
    else return 'Ukjent feil! Vennligst kontakt support om dette ikke løser seg med oppdatering av siden.';
}
